import React, { useEffect, useState } from "react";
import ukflag from "../assets/flag/uk.png";
import jpflag from "../assets/flag/jp.png";
import cnflag from "../assets/flag/cn.png";
import { useNavigate } from "react-router-dom";
import { URL_LANGUAGE } from "../../constants/inital-lang.c";
import { Select, MenuItem } from "@mui/material";
import { LANGUAGES } from "../../constants/languages.c";

const SelectLanguage = () => {
  const [language, setLanguage] = useState(URL_LANGUAGE);
  const navigate = useNavigate();
  const handleChange = (event: any) => {
    const selectedLanguage = event.target.value;
    localStorage.setItem("lang", selectedLanguage);
    let modifiedURL = window.location.pathname;
    // strip any existing language prefix from the url
    Object.values(LANGUAGES).forEach((lang) => {
      if (modifiedURL.startsWith(`/${lang}/`)) {
        modifiedURL = modifiedURL.replace(`/${lang}/`, "/");
      }
    });
    // english stays on the un-prefixed routes, other languages get their prefix
    if (selectedLanguage !== LANGUAGES.EN) {
      modifiedURL = `/${selectedLanguage}${modifiedURL}`;
    }
    navigate(modifiedURL);
    window.location.reload();
  };

  useEffect(() => {
    setLanguage(URL_LANGUAGE);
  }, [language]);

  const Menus = [
    {
      value: LANGUAGES.EN,
      src: ukflag,
      alt: "ukflag",
      label: "English",
    },
    {
      value: LANGUAGES.JP,
      src: jpflag,
      alt: "jpflag",
      label: "日本",
    },
    {
      value: LANGUAGES.CN,
      src: cnflag,
      alt: "cnflag",
      label: "中文",
    },
  ];
  return (
    <>
      <div className="language-select">
        <Select
          className="language-selection"
          placeholder="Select Language"
          onChange={handleChange}
          value={language}
        >
          {Menus.map((item: any, index: number) => {
            return (
              <MenuItem value={item.value} key={index}>
                <img className="flag-img" src={item.src} alt={item.alt} />
                <span className="language-label">{item.label}</span>
              </MenuItem>
            );
          })}
        </Select>
      </div>
    </>
  );
};
export default SelectLanguage;
